import { render, staticRenderFns } from "./CreateDiagnosticModal.vue?vue&type=template&id=0dffede0"
import script from "./CreateDiagnosticModal.vue?vue&type=script&lang=js"
export * from "./CreateDiagnosticModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports